import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from 'primereact/progressspinner';
import { instance } from "../../api";
import Pagination from "./Pagination";
import "./Pagination.css";

export default function DownloadLogs() {
    const [logs, setLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setDataPerPage] = useState(20);

    const dt = useRef(null);

    // Fonction pour formater la date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    useEffect(() => {
        instance
            .get(`/api/fichiers/download-logs`)
            .then((result) => {
                const sortedLogs = result.data.logs.sort((a, b) =>
                    new Date(b.timestamp) - new Date(a.timestamp)
                );
                setLogs(sortedLogs);
                setFilteredLogs(sortedLogs);
            })
            .catch((error) => {
                console.error("Erreur lors du chargement des logs:", error);
            });
    }, []);

    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchText(value);

        const filtered = logs.filter((log) =>
            log.id_fichier_gexpertise.toLowerCase().includes(value) ||
            log.id_utilisateur_gexonline.toString().includes(value) ||
            (log.id_utilisateur_gexpertise && log.id_utilisateur_gexpertise.toLowerCase().includes(value)) ||
            formatDate(log.timestamp).toLowerCase().includes(value) // Recherche sur la date formatée
        );
        setFilteredLogs(filtered);
        setCurrentPage(1); // Revenir à la première page lors d'une nouvelle recherche
    };

    const totalPages = Math.ceil((filteredLogs.length || 0) / dataPerPage);
    const lastIndex = currentPage * dataPerPage;
    const firstIndex = lastIndex - dataPerPage;
    const currentData = filteredLogs.slice(firstIndex, lastIndex);

    const header = (
        <div className="table-header">
            <h5>Téléchargement Logs</h5>
            <span className="p-input-icon-right">
                <InputText
                    type="search"
                    value={searchText}
                    onChange={handleSearchChange}
                    placeholder="Rechercher..."
                />
                <i className="pi pi-search" />
            </span>
        </div>
    );

    return (
        <div className="datatable-crud">
            {logs.length > 0 ? (
                <DataTable
                    ref={dt}
                    value={currentData}
                    header={header}
                    className="crudTable"
                    scrollable
                    scrollHeight="450px"
                    emptyMessage="Aucun résultat trouvé"
                >
                    <Column
                        field="id_fichier_gexpertise"
                        header="ID Fichier"
                        style={{ maxWidth: "20rem" }}
                        body={(rowData) => (
                            <div className="table-data">
                                <span className="mobile-header">ID Fichier </span>
                                {rowData.id_fichier_gexpertise}
                            </div>
                        )}
                    />
                    <Column
                        field="id_utilisateur_gexonline"
                        header="ID Utilisateur gexonline"
                        style={{ maxWidth: "20rem" }}
                        body={(rowData) => (
                            <div className="table-data">
                                <span className="mobile-header">ID Utilisateur gexonline </span>
                                {rowData.id_utilisateur_gexonline}
                            </div>
                        )}
                    />
                    <Column
                        field="id_utilisateur_gexpertise"
                        header="ID Odoo"
                        style={{ maxWidth: "20rem" }}
                        body={(rowData) => (
                            <div className="table-data">
                                <span className="mobile-header">ID Odoo </span>
                                {rowData.id_utilisateur_gexpertise || 'N/A'}
                            </div>
                        )}
                    />
                    <Column
                        field="timestamp"
                        header="Date"
                        style={{ maxWidth: "20rem" }}
                        body={(rowData) => (
                            <div className="table-data">
                                <span className="mobile-header">Date </span>
                                {formatDate(rowData.timestamp)}
                            </div>
                        )}
                    />
                </DataTable>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <ProgressSpinner />
                </div>
            )}
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                dataPerPage={dataPerPage}
                setDataPerPage={setDataPerPage}
                handlePageChange={setCurrentPage}
            />
        </div>
    );
}
